import { useEffect } from 'react';
import tocbot from 'tocbot';
import { useRouter } from 'next/router';
import { toNumber } from 'lodash';

const VerticalBar = () => {
  const router = useRouter();
  const tocbotOptions = {
    tocSelector: '.js-toc',
    contentSelector: '.js-toc-content',
    headingSelector: 'h1, h2',
    scrollSmoothOffset: -70,
    headingsOffset: 64,
    collapseDepth: 20,
  };

  useEffect(() => {
    tocbot?.init(tocbotOptions);
    const hash = router.asPath.split('#')[1];
    if (hash) {
      const element = document.getElementById(hash);
      const offset = toNumber(element?.offsetTop) + 20;
      window.scrollTo({ top: offset, behavior: 'smooth' });
    }

    return () => {
      tocbot?.destroy();
    };
  }, []);

  return (
    <div className='sticky top-[92px] left-0 h-fit min-w-[380px] max-w-[380px] rounded-[16px] bg-paper py-[16px] shadow-1'>
      <nav className='toc js-toc' />
    </div>
  );
};

export default VerticalBar;
